import {inject, Pipe, PipeTransform} from '@angular/core';
import {DexSecuritiesSubjectService} from '../dex/dex-streaming/subjects/dex-securities-subject-service';
import {Deliverable} from '../dex/dex-streaming/types/deliverable';
import {addCurrencyToDisplayDecimal, DisplayDecimal} from '../symbol-decimals';
import {createDisplayDecimalFromBigint} from '../symbol-decimals/display-decimal-bigint';

@Pipe({
    name: 'bigintDeliverableDisplayDecimal'
})
export class BigintDeliverableDisplayDecimalPipe implements PipeTransform {

    private readonly dexSecuritiesSubjectService = inject(DexSecuritiesSubjectService);

    public transform(value: bigint | string, deliverable: Deliverable): DisplayDecimal<string> {
        const displayDecimal = createDisplayDecimalFromBigint(value, deliverable?.decimalPlaces);

        if (deliverable && displayDecimal) {
            const symbol = this.dexSecuritiesSubjectService.getDelDisplaySymbol(deliverable);

            addCurrencyToDisplayDecimal(displayDecimal, symbol);
        }

        return displayDecimal;
    }

}
